
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Events = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const events = [
    {
      id: 1,
      title: 'GCC Job Fair 2024',
      date: '2024-03-15',
      time: '10:00 AM - 6:00 PM',
      location: 'Dubai World Trade Centre',
      category: 'job-fair',
      image: 'https://readdy.ai/api/search-image?query=Professional%20job%20fair%20event%20in%20Dubai%20with%20recruitment%20booths%2C%20people%20networking%2C%20modern%20exhibition%20hall%2C%20business%20atmosphere%2C%20professional%20setting%2C%20corporate%20environment&width=400&height=250&seq=event1&orientation=landscape',
      description: 'Join us at the largest GCC recruitment event featuring top employers from Qatar, UAE, Saudi Arabia, Kuwait, and Oman.',
      status: 'upcoming'
    },
    {
      id: 2,
      title: 'Healthcare Professionals Meetup',
      date: '2024-02-28',
      time: '2:00 PM - 5:00 PM',
      location: 'Doha Convention Center',
      category: 'networking',
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20professionals%20networking%20event%20in%20modern%20conference%20room%2C%20medical%20professionals%20discussing%20opportunities%2C%20clean%20professional%20environment%2C%20business%20meeting%20atmosphere&width=400&height=250&seq=event2&orientation=landscape',
      description: 'Exclusive networking event for healthcare professionals seeking opportunities in GCC countries.',
      status: 'completed'
    },
    {
      id: 3,
      title: 'Construction Industry Workshop',
      date: '2024-04-10',
      time: '9:00 AM - 4:00 PM',
      location: 'Kuwait City Business Center',
      category: 'workshop',
      image: 'https://readdy.ai/api/search-image?query=Construction%20industry%20workshop%20with%20professionals%20in%20hard%20hats%2C%20modern%20conference%20room%2C%20construction%20planning%20documents%2C%20professional%20training%20environment%2C%20business%20setting&width=400&height=250&seq=event3&orientation=landscape',
      description: 'Learn about construction opportunities and requirements across GCC markets.',
      status: 'upcoming'
    },
    {
      id: 4,
      title: 'Hospitality Careers Summit',
      date: '2024-01-20',
      time: '11:00 AM - 7:00 PM',
      location: 'Riyadh International Convention Center',
      category: 'summit',
      image: 'https://readdy.ai/api/search-image?query=Hospitality%20industry%20summit%20with%20hotel%20professionals%2C%20elegant%20conference%20setting%2C%20luxury%20hospitality%20environment%2C%20professional%20networking%20event%2C%20business%20atmosphere&width=400&height=250&seq=event4&orientation=landscape',
      description: 'Premier event for hospitality professionals exploring career opportunities in luxury hotels and resorts.',
      status: 'completed'
    }
  ];

  const youtubeVideos = [
    {
      id: 1,
      title: 'Success Stories: From India to Qatar',
      videoId: 'q3tUqTl7iS8',
      thumbnail: 'https://readdy.ai/api/search-image?query=Healthcare%20professionals%20in%20Kuwait%20hospital%2C%20medical%20career%20opportunities%2C%20modern%20medical%20facility%2C%20professional%20healthcare%20environment%2C%20medical%20staff&width=320&height=180&seq=video6&orientation=landscape',
      description: 'Watch how Rajesh transformed his career with our placement services in Qatar.',
      views: '15K',
      duration: '8:45'
    },
    {
      id: 2,
      title: 'GCC Work Visa Process Explained',
      videoId: 'q3tUqTl7iS8',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20consultant%20explaining%20visa%20documents%2C%20office%20setting%2C%20immigration%20paperwork%2C%20business%20consultation%2C%20professional%20guidance%2C%20clean%20modern%20office&width=320&height=180&seq=video2&orientation=landscape',
      description: 'Complete guide to obtaining work visas for GCC countries.',
      views: '28K',
      duration: '12:30'
    },
    {
      id: 3,
      title: 'Top 10 Jobs in UAE 2024',
      videoId: 'q3tUqTl7iS8',
      thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Dubai%20skyline%20with%20business%20professionals%2C%20UAE%20job%20market%20overview%2C%20corporate%20buildings%2C%20professional%20opportunities%2C%20business%20district&width=320&height=180&seq=video3&orientation=landscape',
      description: 'Discover the most in-demand jobs and salary ranges in the UAE.',
      views: '42K',
      duration: '10:15'
    },
    {
      id: 4,
      title: 'Interview Tips for GCC Jobs',
      videoId: 'q3tUqTl7iS8',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20job%20interview%20preparation%2C%20business%20consultant%20giving%20advice%2C%20modern%20office%20setting%2C%20interview%20coaching%20session%2C%20professional%20guidance&width=320&height=180&seq=video4&orientation=landscape',
      description: 'Expert tips to ace your job interviews in GCC countries.',
      views: '35K',
      duration: '15:20'
    },
    {
      id: 5,
      title: 'Life in Saudi Arabia: Expat Guide',
      videoId: 'q3tUqTl7iS8',
      thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Saudi%20Arabia%20cityscape%20with%20expat%20professionals%2C%20lifestyle%20guide%2C%20contemporary%20urban%20environment%2C%20professional%20life%2C%20cultural%20adaptation&width=320&height=180&seq=video5&orientation=landscape',
      description: 'Everything you need to know about living and working in Saudi Arabia.',
      views: '22K',
      duration: '18:45'
    },
    {
      id: 6,
      title: 'Healthcare Jobs in Kuwait',
      videoId: 'q3tUqTl7iS8',
      thumbnail: 'https://readdy.ai/api/search-image?query=Healthcare%20professionals%20in%20Kuwait%20hospital%2C%20medical%20career%20opportunities%2C%20modern%20medical%20facility%2C%20professional%20healthcare%20environment%2C%20medical%20staff&width=320&height=180&seq=video6&orientation=landscape',
      description: 'Explore lucrative healthcare career opportunities in Kuwait.',
      views: '18K',
      duration: '11:30'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Events' },
    { id: 'job-fair', label: 'Job Fairs' },
    { id: 'networking', label: 'Networking' },
    { id: 'workshop', label: 'Workshops' },
    { id: 'summit', label: 'Summits' }
  ];

  const filteredEvents = selectedCategory === 'all' 
    ? events 
    : events.filter(event => event.category === selectedCategory);

  const handleVideoClick = (videoId: string) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20business%20conference%20event%20with%20people%20networking%2C%20modern%20event%20venue%2C%20corporate%20gathering%2C%20business%20networking%20atmosphere%2C%20professional%20environment%2C%20conference%20hall&width=1920&height=600&seq=events-hero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Events & Success Stories
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto">
            Join our events and watch inspiring success stories from professionals who found their dream careers in GCC countries
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap">
              Register for Events
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap">
              Watch Videos
            </button>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Upcoming Events
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Join our exclusive events to network with top employers and discover new opportunities
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-colors duration-200 whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Events Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {filteredEvents.map((event) => (
              <div key={event.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-200">
                <div className="relative">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-sm font-medium ${
                    event.status === 'upcoming' 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-gray-100 text-gray-800'
                  }`}>
                    {event.status === 'upcoming' ? 'Upcoming' : 'Completed'}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {event.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {event.description}
                  </p>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center text-gray-700">
                      <i className="ri-calendar-line text-blue-600 mr-3 w-5 h-5 flex items-center justify-center"></i>
                      <span className="text-sm">{new Date(event.date).toLocaleDateString()} at {event.time}</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                      <i className="ri-map-pin-line text-blue-600 mr-3 w-5 h-5 flex items-center justify-center"></i>
                      <span className="text-sm">{event.location}</span>
                    </div>
                  </div>
                  <button className={`w-full py-3 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap ${
                    event.status === 'upcoming'
                      ? 'bg-blue-600 hover:bg-blue-700 text-white'
                      : 'bg-gray-100 text-gray-600 cursor-not-allowed'
                  }`}>
                    {event.status === 'upcoming' ? 'Register Now' : 'Event Completed'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* YouTube Videos Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Success Stories & Career Guides
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Watch inspiring success stories and get expert advice for your GCC career journey
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {youtubeVideos.map((video) => (
              <div 
                key={video.id} 
                className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-200 cursor-pointer"
                onClick={() => handleVideoClick(video.videoId)}
              >
                <div className="relative">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-200">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center">
                      <i className="ri-play-fill text-white text-2xl w-8 h-8 flex items-center justify-center"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black bg-opacity-80 text-white px-2 py-1 rounded text-xs">
                    {video.duration}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">
                    {video.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {video.description}
                  </p>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center">
                      <i className="ri-eye-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      <span>{video.views} views</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-youtube-fill text-red-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
                      <span>Watch on YouTube</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <button 
              onClick={() => window.open('https://www.youtube.com/@bichatravelshrconsultants7251', '_blank')}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 whitespace-nowrap"
            >
              <i className="ri-youtube-fill mr-3 w-5 h-5 flex items-center justify-center inline-flex"></i>
              Subscribe to Our Channel
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Stay Updated with Our Events
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Subscribe to our newsletter and never miss an opportunity to advance your career
          </p>
          <div className="max-w-md mx-auto">
            <div className="flex gap-4">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-blue-300 text-gray-900"
              />
              <button className="bg-white text-blue-600 hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Events;
